"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInstantSearchPickupPointsQueryConfig = void 0;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _utils = require("../utils");
var _usePickupPointsSearchConfiguration = require("./usePickupPointsSearchConfiguration");
const useInstantSearchPickupPointsQueryConfig = () => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    maxDisplayedSearchResults,
    mapConfiguration: {
      provider: mapProvider = undefined
    } = {}
  } = (0, _usePickupPointsSearchConfiguration.usePickupPointsSearchConfiguration)();
  const headers = (0, _utils.getHeaders)({
    currentLanguage: language,
    tenant
  });
  const resultsLimit = {
    skip: 0,
    top: maxDisplayedSearchResults
  };
  return {
    mapProvider,
    headers,
    resultsLimit,
    tenant
  };
};
exports.useInstantSearchPickupPointsQueryConfig = useInstantSearchPickupPointsQueryConfig;